module.exports = __webpack_public_path__ + "img/graph_vetor_red.311af0d3.svg";